/**
 * Created by Viacheslav Stepanian on 02.09.2026
 */

const SuppliesWindow = Prefab.createWindow("supplies_window", "supplies_window_prefab_json");
